module.exports = __webpack_public_path__ + "static/media/pdf_footer_regular.9e214165.png";